/**
 * One-time Leaflet bootstrap. Import this once at app start (main.jsx) so that:
 *  - the Leaflet + MarkerCluster stylesheets are bundled, and
 *  - the default marker icon points at the bundled PNGs, and
 *  - Leaflet's "🇺🇦 Leaflet" link is dropped from every map's attribution.
 *
 * Without the icon fix, Leaflet resolves `marker-icon.png` against the page URL
 * and every default <Marker> renders as a broken image under Vite.
 */
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import "./leafletSetup.css";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// The base maps are Google (logo + credits drawn by MapLayers' GoogleAttribution),
// so the bottom-right box should only carry real data credits (Esri, Bhuvan,
// APSAC…), not a link to the rendering library. Leaflet's BSD-2 licence needs
// no on-map credit. Set on the prototype so every map, present and future, gets it.
L.Control.Attribution.prototype.options.prefix = false;

export default L;
